export function modalPopup() {
	const modalPopup = document.getElementById('modal-popup');
	if (!modalPopup) {
		return;
	}
	const closeButton = modalPopup.querySelector('#modal-popup__close-btn');

	closeButton.addEventListener('click', () => {
		closePopup(modalPopup);
	});

	window.addEventListener('click', (event) =>
		closePopupOnClickOutside(event, modalPopup)
	);

	const triggers = document.querySelectorAll('[data-modalpopuptrigger]');

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', function () {
			const triggerName = trigger.dataset.modalpopuptrigger;
			triggerModalPopup(triggerName);
		});
	});
}

export function triggerPopup(triggerName) {
	triggerModalPopup(triggerName);
}

function closePopup(modalPopup) {
	modalPopup.classList.remove('open');
}

function closePopupOnClickOutside(event, modalPopup) {
	if (event.target === modalPopup) {
		closePopup(modalPopup);
	}
}

function shouldShowContinueButton() {
	return window.location.pathname === '/user-dashboard';
}

export function triggerModalPopup(
	triggerName,
	options = {includeContinueButton: true}
) {
	const modalPopup = document.getElementById('modal-popup');
	if (!modalPopup) {
		return;
	}
	const popupContent = document.querySelector('.modal-popup__content');
	if (!popupContent) {
		return;
	}
	const continueButton = document.querySelector('.continue-button');
	popupContent.innerHTML = '';
	const modalPopupContent = document
		.querySelector(`[data-modalpopupcontent=${triggerName}]`)
		.cloneNode(true);

	if (modalPopupContent) {
		popupContent.appendChild(modalPopupContent);
	}
	if (options.includeContinueButton) {
		if (shouldShowContinueButton()) {
			if (!popupContent.querySelector('.continue-button-cloned')) {
				const clonedButton = continueButton.cloneNode(true);
				clonedButton.classList.add('continue-button-cloned');
				popupContent.appendChild(clonedButton);
			}
		}
	}
	modalPopup.classList.add('open');
	openNewcomerVideo(popupContent, modalPopup);
}

function openNewcomerVideo(popupContent, modalPopup) {
	const dashboard = document.querySelector('section.user-dashboard');
	if (!dashboard) return;

	if (dashboard.dataset.newuser) {
		const startingTopicLink = dashboard.dataset.startingtopiclink;
		const overlayVideo = dashboard.querySelector(
			'.user-dashboard__campus-overlay-video'
		);
		const overlayVideoElement = overlayVideo.querySelector('video');
		const continueButton = popupContent.querySelector('.continue-button');
		const overlayCloseButton = dashboard.querySelector(
			'.user-dashboard__campus-overlay-close-button'
		);

		continueButton.addEventListener('click', (event) => {
			event.preventDefault();
			closePopup(modalPopup);
			overlayVideo.classList.add(
				'user-dashboard__campus-overlay-video--visible'
			);
			overlayVideoElement.play();
		});

		const videoSrc = dashboard.dataset.introvideo;
		overlayVideoElement.src = videoSrc;
	}
}
